var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"text":"","prominent":"","type":"success"}},[_vm._v(" "+_vm._s(_vm.$t('page.logout.content'))+" ")]),_c('div',{staticClass:"text-center"},[_c('a',{attrs:{"href":"/"}},[_vm._v(" "+_vm._s(_vm.$t('page.logout.link'))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }